module.exports = __webpack_public_path__ + "static/media/battery_eng_04.0a65b234.png";